/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { removeTimeZoneFromDate, toDateStringOnly } from 'utils/dateUtil';
import { configAppInstance } from '../../../configureApp';
import { step17ExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/step17DataMapper.js